import styled from 'styled-components'
import { colors } from 'styles/theme'

export const CdContainer = styled.div<any>`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 13px;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  padding: 15px 24px;
  border-radius: 8px;
  width: ${({ width }) => (width ? width : null)};
  font-size: 14px;
  line-height: 20px;
  position: relative;
  transition: 300ms all;
`

export const CdToggleArrow = styled.div<{ open: boolean }>`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: 300ms transform;

  img {
    transform: rotate(-90deg);
  }
`

export const CdHamburgIcon = styled.div`
  color: ${colors.primary};
`

export const CdOptionsList = styled.div<{ anchor?: string }>`
  position: absolute;
  top: ${({ anchor }) => (anchor === 'bottom' || !anchor ? '110%' : null)};
  bottom: ${({ anchor }) => (anchor === 'top' ? '140%' : null)};
  left: 0;
  right: 0;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  z-index: 100;
  /* border-width: 1px; */
  /* border-style: solid; */
  padding: 8px;
  max-height: 270px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`

export const CdOptionsListItem = styled.div`
  padding: 10px 14px 10px 8px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  transition: 300ms all;

  :hover {
  }
`

export const CustomDropdownOptionsListItem = styled.div`
  padding: 16px 24px;
  font-size: 16px;
  line-height: 19px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const VotingPowerText = styled.div`
  font-size: 13px;
`
